import createFacet from '@bottlebooks/gatsby-theme-event/src/components/Filters/createFacet';
import incCount from '@bottlebooks/gatsby-theme-event/src/components/Filters/helpers/incCount';
import stringIsEqual from '@bottlebooks/gatsby-theme-event/src/components/Filters/helpers/stringIsEqual';
import get from 'lodash/get';

export default createFacet(
  {
    // state, initialValue and prepare are defined in createFacet.

    // The reducer for the facet values.
    reducer: (facetValues, item) => {
      const withClassifications = incCount(
        facetValues,
        get(item, 'classification')
      );
      return incCount(withClassifications, get(item, 'specialClassification'));
    },

    // Tests if an item matches a certain filter.
    matches: ({ classifications: filterValues }) => {
      if (!filterValues?.length) return () => true;
      return (item) =>
        filterValues.some(
          (value) =>
            stringIsEqual(get(item, 'classification'), value) ||
            stringIsEqual(get(item, 'specialClassification'), value)
        );
    },
  },

  { sortBy: 'count', sortDirection: 'desc' }
);
